import theme from '../../../../themes/green';

const style = {
  container: {
    display: 'flex',
    flex: 1,
  },
  head: Object.assign(...theme.font, {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: '500',
    color: '#476166',
    backgroundColor: 'white',
    textTransform: 'uppercase',
    width: '100%',
    height: '40px',
    display: 'flex',
    flexDirection: 'row',
  }),
  cell: {
    verticalAlign: 'middle',
    padding: '10px',
  },
  table: {
    display: 'flex',
    flex: 1,
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    flexDirection: 'column',
  },
  odd: {
    backgroundColor: '#F5F5F5',
  },
  even: {
    backgroundColor: '#FFFFFF',
  },
};

export default style;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListTable/ProjectListTable.styles.js